import React, { ComponentProps } from 'react';
import { asBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { ViewModeSwitch } from '../../_lib/components/ViewModeSwitch/ViewModeSwitch';
import { ExecutiveOrganizationChartView } from './partials/ExecutiveOrganizationChart/ExecutiveOrganizationChart';
import { InstantView } from '../../types/BlockWithViews';
import { PageTreeWithFilters } from './partials/PageTreeWithFilters';

type StructuralPageToPageTree = {
  views: {
    default: {
      embedded: {
        pageTreeWithFilters: PageTreeWithFilters,
      },
    },
    gvp: InstantView<ExecutiveOrganizationChartView>,
  }
};

export function StructuralPageToPageTree({
  views,
}: StructuralPageToPageTree) {
  const { t } = useSonTranslation('StructuralPageToPage');

  if (views.gvp) {
    return (
      <ViewModeSwitch switches={[
        { href: '?active-view=default', text: t('listView'), default: true },
        { href: '?active-view=gvp', text: t('executiveOrganizationChart') },
      ]}
      >
        {(searchParams) => {
          let currentView = searchParams.get('active-view');
          return (
            <>
              {currentView === 'gvp' && views.gvp ? <ExecutiveOrganizationChartView {...views.gvp} /> : null}
              {currentView === 'default' || !currentView
                ? <PageTreeWithFilters {...views.default.embedded.pageTreeWithFilters} />
                : null}
            </>
          );
        }}
      </ViewModeSwitch>
    );
  }

  return <PageTreeWithFilters {...views.default.embedded.pageTreeWithFilters} />;
}

export const StructuralPageToPageTreeBlock = asBlock(StructuralPageToPageTree, BlockType.structuralPageToPageTree);
export type StructuralPageToPageTreeBlock = ComponentProps<typeof StructuralPageToPageTreeBlock>;
